import * as Yup from 'yup'

export const DEFAULT_FORM_VALUES = {
  position_title: '',
  job_level_id: '',
  job_background_id: '',
  position_type: '',
  min_salary: '',
  max_salary: '',
  work_location: '',
  city: '',
  state: '',
  job_advertisement_duration: '',
  job_description: '',
  job_requirement: '',
  grade_requirement: '',
  year_of_experience: '',
  qualification_id: '',
  fresh_grade_placement: '',
  skill: '',
  course: '',
}

export const jobAdValidation = {
  position_title: Yup.string().max(50, 'Maximum 50 characters').required('Required'),
  job_level_id: Yup.number().integer().required('Required').nullable(),
  job_background_id: Yup.number().integer().required('Required').nullable(),
  position_type: Yup.string().max(50, 'Maximum 50 characters').required('Required').nullable(),
  min_salary: Yup.number().required('Required').nullable(),
  max_salary: Yup.number()
    .min(Yup.ref('min_salary'), 'Must be greater than or equal to minimum salary')
    .required('Required')
    .nullable(),
  work_location: Yup.string().max(200, 'Maximum 200 characters').required('Required').nullable(),
  city: Yup.string().max(30, 'Maximum 30 characters').required('Required').nullable(),
  state: Yup.string().max(50, 'Maximum 50 characters').required('Required').nullable(),
  job_description: Yup.string()
    .max(2000, 'Maximum 2000 characters')
    .required('Required')
    .nullable(),
  qualification_id: Yup.number().integer().required('Required').nullable(),
  skill: Yup.array()
    .test('skill', 'At least 3 skills required', (value) => value?.length >= 3 && value?.join(', '))
    .nullable(),
  grade_requirement: Yup.number().nullable(),
  year_of_experience: Yup.number()
    .integer('Must be integer')
    .moreThan(0, 'Minimum 1 year')
    .required('Required')
    .nullable(),
  fresh_grade_placement: Yup.number().integer('Must be integer').nullable(),
  job_requirement: Yup.string()
    .max(2000, 'Maximum 2000 characters')
    .required('Required')
    .nullable(),
  job_advertisement_duration: Yup.number()
    .integer('Must be integer')
    .moreThan(0, 'Required')
    .required('Required')
    .nullable(),
}

export const TopUpCreditValidation={
  credit_value:Yup.number().integer('Please enter a whole number').round().strict().min(10, 'Minimum amount is RM 10').required('Required')
}
export const createDraftValidation={
  position_title: Yup.string().max(50, 'Maximum 50 characters').required('Required'),
  position_type: Yup.string().max(50, 'Maximum 50 characters').required('Required'),

}

export const DEFAULT_CREATE_DRAFT={
  position_title: '',
  position_type: ''
}
export const DEFAULT_TOP_UP_CREDIT={
  credit_value:''
}

export const DEFAULT_ACTIVATE_ADS={
  job_advertisement_duration:90
}